import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { reputationList } from '@/mocks/movies';

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '夜猫电影院',
  url: 'https://www.nightowlcinema.com',
  description: '夜猫电影院提供高清电影免费在线观看，免费电视剧全集不卡顿，高清画质秒播，熬夜追剧不缓冲。',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    email: 'contact@nightowlcinema.com',
    availableLanguage: ['Chinese'],
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '夜猫电影院的视频画质如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '夜猫电影院所有影视内容均提供高清画质，支持1080P超清播放。我们采用先进的视频压缩和CDN加速技术，确保观影过程中流畅不卡顿，让您享受影院级的观影体验。',
      },
    },
    {
      '@type': 'Question',
      name: '夜猫电影院需要付费吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '完全免费！夜猫电影院承诺永远不对用户收取任何费用。所有电影、电视剧、综艺等内容均可免费在线观看，无广告干扰，无需会员注册。',
      },
    },
    {
      '@type': 'Question',
      name: '更新速度快吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '夜猫电影院拥有专业的资源更新团队，热门影视剧在首播后数小时内即可上架。电影、电视剧、综艺节目等均保持每日更新，确保您不会错过任何精彩内容。',
      },
    },
    {
      '@type': 'Question',
      name: '支持哪些设备观看？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '夜猫电影院支持全平台观看，包括电脑、平板和手机。无论是在家用大屏电脑，还是外出用手机追剧，都能享受流畅的高清观影体验。',
      },
    },
  ],
};

const breadcrumbJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.nightowlcinema.com/' },
    { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.nightowlcinema.com/about' },
  ],
};

export default function AboutPage() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <div className="min-h-screen bg-background-950">
        <Navbar />
        <main>
          <section className="relative w-full h-[260px] md:h-[350px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=dark%20cinema%20theater%20interior%20with%20warm%20golden%20lighting%20empty%20red%20seats%20atmospheric%20movie%20theater%20elegant%20dark%20background%20cinematic%20moody%20ambiance%20professional%20photography&width=1920&height=600&seq=about-hero&orientation=landscape"
              alt="夜猫电影院"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-background-950"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center px-4">
                <nav className="flex items-center justify-center gap-2 text-sm mb-3" aria-label="Breadcrumb">
                  <a href="/" className="text-foreground-400 hover:text-primary-400 transition-colors">首页</a>
                  <i className="ri-arrow-right-s-line text-foreground-500 text-xs"></i>
                  <span className="text-primary-400">关于我们</span>
                </nav>
                <h1 className="text-2xl md:text-4xl font-bold text-white font-heading">关于夜猫电影院</h1>
                <p className="text-foreground-300 text-sm md:text-base mt-3 max-w-xl mx-auto">
                  高清电影免费在线观看，免费电视剧大全不缓冲
                </p>
              </div>
            </div>
          </section>

          <section className="px-4 md:px-6 py-10 md:py-16 max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 mb-12">
              <div className="text-center p-6 rounded-xl bg-background-900/80 border border-background-700/30">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-500/10">
                  <i className="ri-movie-line text-2xl text-primary-400"></i>
                </div>
                <h3 className="text-3xl font-bold text-white font-heading mb-1">10000+</h3>
                <p className="text-sm text-foreground-400">影视资源</p>
              </div>
              <div className="text-center p-6 rounded-xl bg-background-900/80 border border-background-700/30">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-500/10">
                  <i className="ri-user-smile-line text-2xl text-primary-400"></i>
                </div>
                <h3 className="text-3xl font-bold text-white font-heading mb-1">500万+</h3>
                <p className="text-sm text-foreground-400">忠实用户</p>
              </div>
              <div className="text-center p-6 rounded-xl bg-background-900/80 border border-background-700/30">
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-500/10">
                  <i className="ri-timer-line text-2xl text-primary-400"></i>
                </div>
                <h3 className="text-3xl font-bold text-white font-heading mb-1">每日更新</h3>
                <p className="text-sm text-foreground-400">秒播不卡顿</p>
              </div>
            </div>

            <article className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold text-white font-heading mb-6">品牌故事</h2>
              <div className="space-y-4 text-sm md:text-base text-foreground-300 leading-relaxed">
                <p>
                  夜猫电影院成立于2020年，由一群热爱电影、电视剧的年轻人共同创建。我们的初心很简单——让所有人都能免费、便捷地享受高清影视内容。
                </p>
                <p>
                  在过去的几年里，夜猫电影院从一个小小的影视分享平台，逐渐成长为拥有<strong>超过500万用户</strong>的在线影院。我们的资源库涵盖了动作片、喜剧片、爱情片、科幻片、恐怖片、动画片等各大类型，以及当下最热门的国产剧、美剧、韩剧、日剧和综艺节目。
                </p>
                <p>
                  我们深知追剧党们对画质和流畅度的极致追求。因此，夜猫电影院持续投入技术研发，采用先进的视频编码技术和高性能CDN分发网络，确保每一位用户都能享受到<strong>高清画质、秒播不卡顿</strong>的极致观影体验。
                </p>
                <p>
                  "熬夜看剧，尽在夜猫"——这不仅是一句口号，更是我们对每一位深夜追剧人的承诺。无论你是想回顾经典老片，还是追最新热播剧，夜猫电影院始终在这里，陪你度过每一个不眠之夜。
                </p>
              </div>
            </article>

            <article className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold text-white font-heading mb-6">用户口碑</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {reputationList.map((item) => (
                  <div key={item.id} className="p-5 rounded-xl bg-background-900/80 border border-background-700/30">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/10">
                        <span className="text-primary-400 font-semibold text-sm">{item.name[0]}</span>
                      </div>
                      <div>
                        <h4 className="text-sm font-semibold text-white">{item.name}</h4>
                        <div className="flex items-center gap-0.5 mt-0.5">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <i
                              key={i}
                              className={`text-xs ${i < item.rating ? 'ri-star-fill text-primary-400' : 'ri-star-fill text-foreground-700'}`}
                            ></i>
                          ))}
                        </div>
                      </div>
                      <span className="ml-auto text-xs text-foreground-500">{item.date}</span>
                    </div>
                    <p className="text-sm text-foreground-300 leading-relaxed">{item.comment}</p>
                  </div>
                ))}
              </div>
            </article>

            <article>
              <h2 className="text-xl md:text-2xl font-bold text-white font-heading mb-6">联系我们</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
                <div className="p-5 rounded-xl bg-background-900/80 border border-background-700/30 text-center">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-500/10">
                    <i className="ri-mail-line text-xl text-primary-400"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-white mb-1">电子邮箱</h3>
                  <p className="text-xs text-foreground-400">contact@nightowlcinema.com</p>
                </div>
                <div className="p-5 rounded-xl bg-background-900/80 border border-background-700/30 text-center">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-500/10">
                    <i className="ri-customer-service-line text-xl text-primary-400"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-white mb-1">在线客服</h3>
                  <p className="text-xs text-foreground-400">7×24小时全天候服务</p>
                </div>
                <div className="p-5 rounded-xl bg-background-900/80 border border-background-700/30 text-center">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-full bg-primary-500/10">
                    <i className="ri-map-pin-line text-xl text-primary-400"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-white mb-1">公司地址</h3>
                  <p className="text-xs text-foreground-400">中国·北京市朝阳区</p>
                </div>
              </div>
            </article>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}